<!--
 * @Author: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @Date: 2023-05-18 10:28:21
 * @LastEditors: DESKTOP-6JOF46S\蔡洋杰 1760178806@qq.com
 * @LastEditTime: 2023-05-20 09:15:56
 * @FilePath: \合联\oms\src\view\order\unboxList\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <cTable :fields="fields" :header="header" :methods="methods" :modals="modals" :config="config" :footer="footer"
    ref="table">
    <template #DETAIL="{ visible, params }">
      <order v-if="visible" :orderDetails="params.dataDetails"></order>
    </template>
    <template #tracker="{ visible, params }">
      <tracker v-if="visible" :fn="methods.getOrderStatus" :statusId="params.id"></tracker>
    </template>
  </cTable>
</template>

<script>
import {
  getOrderDetails,
  unbox,
} from "@/api/order/list";
import cTable from '@/base/common/index';
import { apis } from '@/api/order/unboxList'
import tracker from "@/base/order_tracker";
import order from "_c/order-details";
export default {
  name: "unboxList",
  components: {
    tracker,
    order,
    cTable
  },
  mounted() {
  },
  data() {
    return {
      methods: {
        getOrderDetails,
        unbox,
        ...apis,
      },
      config: {},
      footer: {},
      modals: {
        unbox: {
          methods: {
            ok({ row, close }) {
              row.airway_number = row.airway_number.split('\n')
              row.unbox = 'YES'
              this.$page.handleRequestMethods("unbox", row, true, true).then((res) => {
                this.$page.getList()
                close();
              });
            },
          },
          config: {
            title: this.$tz('设置开箱'),
            modalBind: {
              width: 600
            },
            formBind: {
              labelWidth: 80
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
              unbox: [
                {
                  required: true,
                  message: "cannot be empty",
                  trigger: "blur",
                },
              ],
            }
          },
          grid: [{ airway_number: 24 }],
          fields: [
            {
              key: 'airway_number',
              name: this.$tz("订单号码"),
              placeholder() {
                return this.$tz('订单号码');
              },
              component: 'Input',
              bind: {
                type: 'textarea',
                autosize: { minRows: 4, },
              },
            },
            {
              key: "unbox",
              name: this.$tz("是否开箱"),
              placeholder: () => this.$tz("是否开箱"),
              component: "Select",
              options: [
                { label: this.$tz('是'), value: 'YES' },
                { label: this.$tz('否'), value: 'NO' },
              ],
            }
          ]
        },
        tracker: {
          config: {
            width: 600,
          },
          contentSlot: 'tracker',
          footer: {
            show: false
          }
        },
        detail: {
          config: {
            width: 1000,
          },
          contentSlot: 'DETAIL',
          footer: {
            show: false
          }
        },
      },
      header: {
        searchs: [
          {
            key: 'client_id',
            placeholder() {
              return this.$tz('客户名称')
            },
            component: 'Select',
            options: [],
            optionsFn: 'getAllClient',
            optionsKey: '',
          },
          {
            key: 'keywords',
            placeholder() {
              return this.$t('keyword');
            },
            component: 'Input',
            bind: {
              type: 'textarea',
              autosize: { minRows: 2, maxRows: 2 },
            },
          },
        ],
        btns: {
          list: [
            {
              name: () => this.$tz('导出'),
              type: 'export',
              fnName: 'export',
              bind: {
                type: 'primary'
              },
              disabled() { return !this.selectAll.length }
            },
            {
              name: () => this.$tz('设置开箱'),
              type: 'unbox',
              fnName: 'unbox',
              bind: {
                type: 'primary'
              },
            },
          ],
          methods: {
            unbox() {
              this.getModal('unbox').open()
            },
            export() {
              this.exportExc()
            }
          }
        }
      },
      fields: [
        {
          type: 'checkbox',
          align: 'center',
          width: 60,
          fixed: 'left',
        },
        {
          name: () => this.$tz('订单号码'),
          key: 'airway_number',
          minWidth: 150,
          copy: true,
          header: {
            copy: true
          },
          fixed: 'left',
          component: 'Button',
          bind: {
            type: 'primary',
            size: 'small'
          },
          methods: {
            click({ row }) {
              this.$page.handleRequestMethods('getOrderDetails', row.id).then(res => {
                this.$page.getModal('detail').open({
                  dataDetails: res.payload,
                  order: true
                }, function () {
                  this.setTitle('详情')
                })
              })
            }
          }
        },
        {
          name: () => this.$tz("操作人"),
          key: "operator_name",
          align: "center",
          minWidth: 120,
        },
        {
          name: () => this.$tz("操作时间"),
          key: "operator_time",
          align: "center",
          minWidth: 150,
        },
        {
          name: () => this.$tz("客户名称"),
          key: "client_name",
          align: "center",
          minWidth: 120,
        },
        {
          name:()=> this.$tz('客服名称'),
          key:'customer_service_name',
          align:'center',
          minWidth:120,
        },
        {
          name:()=> this.$tz('销售名称'),
          key:'salesman_name',
          align:'center',
          minWidth:120,
        },
        {
          name: () => this.$tz('客户单号'),
          key: 'client_refer_code',
          minWidth: 110,
        },
        {
          name: () => this.$tz("轨迹代码"),
          key: "status",
          align: "center",
          minWidth: 80,
        },
        {
          key: 'status_remarks',
          name: () => this.$tz('轨迹描述'),
          align: "center",
          minWidth: 130,
        },
        {
          key: 'status_time',
          name: () => this.$tz('轨迹,时间'),
          align: "center",
          minWidth: 140,
        },
        {
          name: () => this.$tz("支付,类型"),
          key: "cod_type",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$tz('订单,类型'),
          key: "type",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$tz("申报价值"),
          key: "values",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$tz("代收金额"),
          key: "cod_amount",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$tz("目的国家"),
          key: "to_country",
          align: "center",
          minWidth: 80
        },
        {
          name: () => this.$tz("城市名称"),
          key: "city_name",
          align: "center",
          minWidth: 110,
        },
        {
          name: () => this.$tz("偏远地区"),
          key: "remote_areas",
          align: "center",
          minWidth: 100,
        },
        {
          name: () => this.$tz("收件人"),
          key: "consignee_contact",
          align: "center",
          minWidth: 140,
          show: () => {
            return this.type !== 'TO_CONFIRMED'
          }
        },
        {
          name: () => this.$tz("收件人电话"),
          key: "consignee_cellular",
          align: "center",
          minWidth: 120,
        },
        {
          name: () => this.$tz("收件人地址"),
          key: "consignee_address",
          align: "center",
          minWidth: 130,
        },
        {
          name: () => this.$tz("代理单号"),
          key: "agent_refer_code",
          align: "center",
          minWidth: 120,
        },
        
        {
          name: () => this.$tz("创建时间"),
          key: "create_time",
          align: "center",
          minWidth: 150
        },
        {
          type: 'btns',
          fixed: 'right',
          name:()=> this.$tz('操作'),
          width: 150,

          list: [
            {
              name: '轨迹',
              type: 'track',
              bind: {
                type: 'success'
              },
              fnName: 'track',
            },
          ],
          methods: {
            track({ row }) {
              this.getModal('tracker').open({ id: row.airway_number }, function () {
                this.setTitle(row.airway_number)
              });
            },
          }
        }
      ]
    }
  }
}
</script>

<style scoped></style>